<div id="canvasContainer">
  <canvas id="fabricCanvas"></canvas>
</div>




// WEBPACK FOOTER //
// ./src/app/detection/canvas-detection/canvas-detection.component.html